export const LegalLayout = ({ eyebrow, title, subtitle, lastUpdated, testId, children }) => {
  return (
    <div data-testid={testId}>
      {/* Header */}
      <section className="py-12 sm:py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-xs uppercase tracking-[0.2em] font-medium text-orange-500 mb-3 animate-fade-in-up">
            {eyebrow}
          </p>
          <h1
            data-testid={`${testId}-heading`}
            className="font-heading text-4xl sm:text-5xl font-bold text-slate-900 tracking-tight mb-4 animate-fade-in-up animation-delay-100"
          >
            {title}
          </h1>
          <p className="text-base sm:text-lg text-slate-600 max-w-2xl mx-auto font-body leading-relaxed animate-fade-in-up animation-delay-200">
            {subtitle}
          </p>
          <p className="text-xs uppercase tracking-wider text-slate-400 mt-6 animate-fade-in-up animation-delay-200">
            Last updated: {lastUpdated}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12 sm:py-20 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-10 font-body text-sm sm:text-base text-slate-600 leading-relaxed">
            {children}
          </div>
        </div>
      </section>
    </div>
  );
};

export const LegalSection = ({ title, children }) => (
  <div>
    <h2 className="font-heading text-xl sm:text-2xl font-semibold text-slate-900 tracking-tight mb-4">
      {title}
    </h2>
    <div className="space-y-4">{children}</div>
  </div>
);

export const LegalList = ({ items }) => (
  <ul className="space-y-2 pl-5 list-disc marker:text-orange-500">
    {items.map((item) => (
      <li key={item}>{item}</li>
    ))}
  </ul>
);
